<template>
  <div id="app">
    <header>
      <!--
      <div id="nav">
        <router-link to="/">Home</router-link> |
        <router-link to="/about">About</router-link>
      </div>
      -->
      <login @onAuthStateChanged="handleAuthStateChanged" />
      <!-- <h1 class="game-header">Duskhelm MVP</h1> -->
    </header>
    <main v-if="isAuthenticated">
      <section class="text-center">
        <img class="main-logo" v-if="$store.state.showLogo"
          alt="The Detectives of Duskhelm" src="./assets/logo.svg">
      </section>
      <router-view />
    </main>
    <footer></footer>
  </div>
</template>
<script>
import Login from '@/components/Login.vue';
// eslint-disable-next-line
import styles from '@/scss/styles.scss';

export default {
  components: {
    Login,
  },
  data() {
    return {
      isAuthenticated: false,
    };
  },
  methods: {
    handleAuthStateChanged(user) {
      // console.log('handleAuthStateChanged', user);
      this.isAuthenticated = !!user;
      if (this.isAuthenticated) {
        this.$store.dispatch('getGameData');
      }
    },
  },
};
</script>

<style lang="scss">

#app {
  font-family: 'Euphorigenic', Helvetica, Arial, sans-serif;
  font-size: 14pt;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding: 1rem;
  height: 100%;
  margin: 0 auto;
  color: #2c3e50;
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-columns: auto;
}
</style>
